module.exports = __webpack_public_path__ + "static/media/60b257f5-da3f-4c78-97c0-7bd6512d614d.b30dddb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/60b257f5-da3f-4c78-97c0-7bd6512d614d.png
// module id = 1467
// module chunks = 0